module.exports = __webpack_public_path__ + "static/media/whole-body-challenge-100k.a12c630b.png";